var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageButtons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 26,
    viewBox: "0 0 81 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.299865 21.5247C-0.655425 23.5963 0.787863 26 2.98703 26H65.8583C67.506 26 68.8417 24.6031 68.8417 22.88V3.12C68.8417 1.39687 67.506 0 65.8583 0H12.0991C10.9538 0 9.90951 0.68578 9.41197 1.76471L0.299865 21.5247Z",
    fill: "#0556CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7001 21.5247C81.6554 23.5963 80.2121 26 78.013 26H15.1417C13.494 26 12.1583 24.6031 12.1583 22.88V3.12C12.1583 1.39687 13.494 0 15.1417 0H68.9009C70.0462 0 71.0905 0.68578 71.588 1.76471L80.7001 21.5247Z",
    fill: "#0556CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageButtons);
export default __webpack_public_path__ + "static/media/pageButtons.2576181b31eea47784b362ac42f7e5d3.svg";
export { ForwardRef as ReactComponent };